<template>
	<form class="form form--has-fixed-group" novalidate>
		<div ref="success" v-show="success" class="alert alert--success">
			{{ currentUser ? 'Your profile has been saved' : 'User profile has been updated' }}
		</div>

		<div class="grid">
			<div class="col-12 col-md-6">
				<fieldset class="form__group">
					<legend>Personal Information</legend>

					<div class="form__group">
						<input id="first-name" name="firstName" class="form__control" v-model="formData.firstName"
						       placeholder="Enter name here..." v-validate required />
						<label for="first-name" class="form__label">Name</label>
						<div class="form__validation">{{ errors.first('firstName') }}</div>
					</div>

					<div class="form__group">
						<input id="last-name" name="lastName" class="form__control" v-model="formData.lastName"
						       placeholder="Enter surname here..." v-validate required />
						<label for="last-name" class="form__label">Surname</label>
						<div class="form__validation">{{ errors.first('lastName') }}</div>
					</div>

					<div class="form__group">
						<input id="phone" type="tel" name="phone" class="form__control"
						       v-model="formData.phone" placeholder="Enter phone number here..."
						       v-validate required />
						<label for="phone" class="form__label">Telephone</label>
						<div class="form__validation">{{ errors.first('phone') }}</div>
					</div>

					<div class="form__group">
						<input id="email" type="email" name="email" class="form__control"
						       v-model="formData.email" placeholder="Enter email address here..."
						       v-validate required />
						<label for="email" class="form__label">Email Address</label>
						<div class="form__validation">{{ errors.first('email') }}</div>
					</div>

					<FileUpload
                        :multiple="false"
                        v-model="formData.avatar"
                        name="avatar"
                        label="Avatar"
                    />

					<FormControlOffice
                        :member="savedFormData.member"
                        v-model="formData.office"
                        name="office"
                        v-validate="'required'"
                    />

					<div class="form__group">
						<input id="position" name="position" class="form__control" v-model="formData.position"
						       placeholder="Enter position here..." v-validate required />
						<label for="position" class="form__label">Position</label>
						<div class="form__validation">{{ errors.first('position') }}</div>
					</div>

					<div class="form__group">
						<input id="website" name="website" class="form__control" v-model="formData.website"
						       placeholder="Enter your website here..." />
						<label for="website" class="form__label">Website</label>
						<div class="form__validation">{{ errors.first('website') }}</div>
					</div>
				</fieldset>
			</div>

			<div class="col-12 col-md-6">
				<fieldset class="form__group">
					<legend>Profile Information</legend>

					<div class="form__group">
						<textarea id="background" name="background" class="form__control"
						          v-model="formData.background"></textarea>
						<label for="background" class="form__label">Background</label>
						<div class="form__validation">{{ errors.first('background') }}</div>
					</div>

					<div class="form__group">
						<textarea id="expertise" name="expertise" class="form__control"
						          v-model="formData.expertise"></textarea>
						<label for="expertise" class="form__label">Expertise</label>
						<div class="form__validation">{{ errors.first('expertise') }}</div>
					</div>

					<div class="form__group">
						<textarea id="career" name="career" class="form__control"
						          v-model="formData.career"></textarea>
						<label for="career" class="form__label">Career</label>
						<div class="form__validation">{{ errors.first('career') }}</div>
					</div>

				</fieldset>
			</div>
		</div>

		<div class="form__group form__group--submit-fixed">
			<button
                class="btn btn--primary"
                @click.prevent="submit"
                v-wait:disabled="waitName"
            >Save Changes</button>
		</div>
	</form>
</template>

<script>
	import API from './../../../api';
	import UserFormTab from './UserFormTab';
	import FormControlOffice from '../../Form/Control/FormControlOffice';
	import FileUpload from '../../Form/FileUpload';
	import ValidationAlert from '../../ValidationAlert';

	export default {
		name: 'UserFormProfile',
		mixins: [UserFormTab],
		components: {
			ValidationAlert,
			FileUpload,
			FormControlOffice,
		},
		data() {
			return {
				waitName: 'updateProfile',
				formData: {
					firstName: null,
					lastName: null,
					office: null,
					phone: null,
					email: null,
					location: null,
					languages: [],
					avatar: null,
					position: null,
					website: null,
					background: null,
					expertise: null,
					career: null,
				},
			};
		},
		methods: {
			save() {
				return API.updateUser(this.id, this.formData);
			}
		}
	}
</script>

<style lang="scss" scoped>
	textarea {
		min-height: 17.5rem;
	}
</style>
